import { render, staticRenderFns } from "./FeeCreate.vue?vue&type=template&id=b068005a"
import script from "./FeeCreate.vue?vue&type=script&lang=js"
export * from "./FeeCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports